import { onMounted, ref } from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { productSpecificationSchema } from '@/schemas/productSpecificationSchema'
import { useRouter } from 'vue-router'
import {getProductById} from '@/api/products'

export const useProductSpecificationForm = (formType: 'add' | 'edit' | 'view'): any => {
  const { values, handleSubmit, errors, setErrors, resetForm, meta, setFieldValue } = useForm({
    validationSchema: toTypedSchema(productSpecificationSchema)
  })

  const toast = useToast()
  const loading = ref(false)
  const router = useRouter()

  const showToast = (type: 'success' | 'error', title: string, message: string) => {
    toast.add({
      severity: type,
      summary: title,
      detail: message,
      life: 5000
    })
  }

  onMounted(async () => {
    if (formType !== 'add') {
      const productSpecificationId = router.currentRoute.value.params.id as string
      const productSpecification = await getProductById(productSpecificationId)

      if (productSpecification) {
        resetForm({
          values: { ...productSpecification }
        })
      }
    }
  })

  return {
    values,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    meta,
    setFieldValue,
    loading,
    showToast,
    formType,
  }
}
